import { useTranslation } from 'react-i18next'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import CheckIcon from '@mui/icons-material/Check'
import { SUPPORTED_LANGUAGES, saveUserLanguage } from '../i18n/language'

// Written in their own language on purpose: someone looking at a UI they
// cannot read must still recognize their own option.
const LANGUAGE_NAMES = {
    pt: 'Português',
    en: 'English'
}

export default function LanguageToggle(props) {
    const { username, onSelect } = props
    const { i18n } = useTranslation()

    function handleSelect(lng) {
        i18n.changeLanguage(lng)
        saveUserLanguage(username, lng)
        if (onSelect) onSelect()
    }

    return SUPPORTED_LANGUAGES.map(lng => {
        const isActive = i18n.language === lng

        return (
            <MenuItem
                key={lng}
                onClick={() => handleSelect(lng)}
                selected={isActive}
                role='menuitemradio'
                aria-checked={isActive}
            >
                {/* The empty icon slot on the inactive row keeps both labels aligned. */}
                <ListItemIcon>{isActive && <CheckIcon fontSize='small' />}</ListItemIcon>
                <ListItemText>{LANGUAGE_NAMES[lng]}</ListItemText>
            </MenuItem>
        )
    })
}
